import {ILiveSiteClubConfig, InfoCmsModuleConfig} from "../reducers/club-settings";

//@TODO find better solution for configure club cms.
export function clubSettingsFetchClubCmsConfig(state: ILiveSiteClubConfig): InfoCmsModuleConfig {
  return <InfoCmsModuleConfig>state.modules.find((module) => module instanceof InfoCmsModuleConfig);
}

export function getCurrentClubId(state: any): string {
  return state.clubSettings.club.id;
}

export function getManagersByClubId(items: any, state: any) {
  return Object.values(items).filter((item: any) => item.club.id === getCurrentClubId(state))
}

export function getClubsByClubId(items: any, state: any) {
  return Object.values(items).filter((item: any) => item.id === getCurrentClubId(state))
}



// WEBPACK FOOTER //
// ./src/selectors/club-settings.ts